<template>
  <div class="breadcrumbs">
    <ul>
      <li>
        <router-link to="/">Home</router-link>
      </li>
      <li>{{name}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BreadCrumbs",
  props: { name }
};
</script>

<style scoped>
.breadcrumbs {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}
.breadcrumbs ul {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 70%;
  margin: 0px;
  padding: 0px;
  list-style: none;
}
.breadcrumbs ul li + li::before {
  color: rgb(204, 204, 204);
  content: "•";
  padding: 0px 5px;
}
.breadcrumbs ul li a,
.breadcrumbs ul li {
  text-decoration: none;
  text-transform: uppercase;
  color: #000;
  font-size: 15px;
  font-weight: 700;
}
</style>
